module.exports = __webpack_public_path__ + "static/media/clap.ca27425c.svg";